import { GetUserPermissionPCResult, MST_USER } from './../model/user.model';
import { Injectable } from '@angular/core';
import { User } from '../model/user.model';

@Injectable()
export class PermissionService {

    private permissionList: Array<GetUserPermissionPCResult>;
    private currentUser: MST_USER = new MST_USER();

    constructor() {
        this.permissionList = new Array<GetUserPermissionPCResult>();
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser) {
            this.permissionList = new Array<GetUserPermissionPCResult>();
            this.permissionList = this.currentUser.Permission;
        }

        console.log("Init Permission");

    }

    public updateCurrentUser = (u: MST_USER): void => {
        this.currentUser = u;
        if (this.currentUser) {
            this.permissionList = new Array<GetUserPermissionPCResult>();
            this.permissionList = this.currentUser.Permission;
        }
    }




    public CheckPermission = (TYPE: any, ACTION: string): boolean => {
        let res: boolean = false;
        // this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

        if (this.currentUser) {
            if (this.currentUser.IS_ADMIN == true) {
                return true;
            }
        }


        if (this.permissionList && this.currentUser) {
            this.permissionList = this.currentUser.Permission;
            let filterByType = this.permissionList.filter(x => x.ObjID == TYPE && x.PermissionID == ACTION);
            if (filterByType.length > 0) {
                return filterByType[0].Permissionflag;
            }
        } else {
            return res;
        }
    }

    public CheckCanAccessURL = (url: string): boolean => {
        let res: boolean = false;

        if (this.permissionList) {
            let checkUrl = this.permissionList.filter(x => x.Description == url);
            if (checkUrl.length > 0) {
                res = checkUrl[0].Permissionflag;
            } else {
                return res;
            }
        } else {
            return res;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/services/permission.service.ts